"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFontUrl = void 0;
const core_1 = require("@mapmaker/core");
function getFontUrl(fontName) {
    return (0, core_1.getMapmakerStaticUrl)(`svg/fonts/${fontName}`);
}
exports.getFontUrl = getFontUrl;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZm9udFV0aWxzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3V0aWxzL2ZvbnRVdGlscy50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEseUNBQXNEO0FBRXRELFNBQWdCLFVBQVUsQ0FBQyxRQUFnQjtJQUN6QyxPQUFPLElBQUEsMkJBQW9CLEVBQUMsYUFBYSxRQUFRLEVBQUUsQ0FBQyxDQUFDO0FBQ3ZELENBQUM7QUFGRCxnQ0FFQyJ9